<template>
  <div class="small">
    <div v-if="loaded" class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-department" class="mb-1">Departamento</label>
          <select
            v-model="departmentU"
            id="ma-department"
            class="form-control form-control-sm"
            required
          >
            <option value="">Seleccionar</option>
            <option v-for="i in deliveryZone.ubigeo" :key="i.id" :value="i.id">
              {{ i.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-province" class="mb-1">Provincia</label>
          <select
            v-model="province"
            id="ma-province"
            class="form-control form-control-sm"
            required
          >
            <option value="">Seleccionar</option>
            <option v-for="i in listProvinces" :key="i.id" :value="i.id">
              {{ i.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-distrit" class="mb-1">Distrito</label>
          <select
            v-model="ubigeoId"
            id="ma-distrit"
            class="form-control form-control-sm"
            required
          >
            <option value="">Seleccionar</option>
            <option v-for="i in listDistricts" :key="i.id" :value="i.id">
              {{ i.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-zone" class="mb-1">Zona de reparto</label>
          <select
            v-model="zoneId"
            id="ma-zone"
            class="form-control form-control-sm"
            required
          >
            <option value="">Seleccionar</option>
            <option v-for="i in listZones" :key="i.zoneId" :value="i.zoneId">
              {{ `${i.zoneName} - S/ ${i.deliveryFee}` }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-address" class="mb-1">Dirección</label>
          <input
            v-model="formAddress.address"
            id="ma-address"
            type="text"
            class="form-control form-control-sm"
            required
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-lot" class="mb-1">Nro/Lote</label>
          <input
            v-model="formAddress.lot"
            id="ma-lot"
            type="text"
            class="form-control form-control-sm"
            required
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-dpto" class="mb-1">Dpto./int (Opcional)</label>
          <input
            v-model="formAddress.department"
            id="ma-dpto"
            type="text"
            class="form-control form-control-sm"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="ma-ubr" class="mb-1">Urbanización (Opcional)</label>
          <input
            v-model="formAddress.urbanization"
            id="ma-ubr"
            type="text"
            class="form-control form-control-sm"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="ma-ref" class="mb-1">Referencia</label>
          <input
            v-model="formAddress.reference"
            id="ma-ref"
            type="text"
            class="form-control form-control-sm"
            required
          >
        </div>
      </div>
    </div>
    <div v-else>
      <i class="fa fa-spin fa-spinner fa-2x"></i>
    </div>
  </div>
</template>
<script>
import api from '../api';

const addressBlank = {
  address: '',
  department: '',
  departmentU: '',
  lot: '',
  province: '',
  reference: '',
  ubigeoId: '',
  urbanization: '',
  zoneId: '',
  zoneMethodId: '',
  name: 'Casa',
  // session: '',
};

export default {
  props: ['value', 'activityId'],
  data() {
    return {
      loaded: false,
      loading: false,
      deliveryZone: {
        data: [],
        ubigeo: [],
      },
      listProvinces: [],
      listDistricts: [],
      listZones: [],
      formAddress: {},
      departmentU: '',
      province: '',
      ubigeoId: '',
      zoneId: '',
      deliveryZoneObj: {},
    };
  },
  watch: {
    departmentU(curr) {
      this.formAddress.departmentU = curr;
      this.changeDepartment();
    },
    province(curr) {
      this.formAddress.province = curr;
      this.changeProvince();
    },
    ubigeoId(curr) {
      this.formAddress.ubigeoId = curr;
      this.changeDistrict();
    },
    zoneId(curr) {
      this.formAddress.zoneId = curr;
      this.changeZone();
    },
    formAddress: {
      handler() {
        this.$emit('input', this.formAddress);
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataDelivery();
    this.initFormAddress();
  },
  methods: {
    initFormAddress() {
      this.formAddress = {
        ...addressBlank,
        ...this.value,
      };
      this.departmentU = this.value.departmentU || '';
      setTimeout(() => {
        this.province = this.value.province || '';
      }, 250);
      setTimeout(() => {
        this.ubigeoId = this.value.ubigeoId || '';
      }, 500);
      setTimeout(() => {
        this.zoneId = this.value.zoneId || '';
      }, 750);
    },
    async getDataDelivery() {
      this.loading = true;
      const url = `/merchandise/deliveries/event?activityId=${this.activityId}`;
      try {
        const { data } = await api.axios.get(url);
        if (data.status) {
          this.loaded = true;
          this.deliveryZone.data = data.data;
          this.deliveryZone.ubigeo = data.ubigeo;
        }
      } catch (err) {
        console.log('Error: getDeliveryZones', err); // eslint-disable-line
      }
      this.loading = false;
    },
    changeDepartment() {
      const dObj = this.deliveryZone.ubigeo.find(i => i.id === this.formAddress.departmentU);
      if (dObj) {
        this.listProvinces = dObj.children;
      }
    },
    changeProvince() {
      const dObj = this.listProvinces.find(i => i.id === this.formAddress.province);
      if (dObj) {
        this.listDistricts = dObj.children;
      }
    },
    changeDistrict() {
      const dObj = this.listDistricts.find(i => i.id === this.formAddress.ubigeoId);
      if (dObj) {
        const listZones = [];
        this.deliveryZone.data.forEach((item) => {
          const locationAux = item.ubigeoId === dObj.id;
          if (locationAux) {
            listZones.push(item);
          }
        });
        this.listZones = listZones;
        this.zoneId = listZones[0].zoneId;
      }
    },
    changeZone() {
      const dObj = this.listZones.find(i => i.zoneId === this.zoneId);
      if (dObj && dObj.deliveryMethod) {
        this.formAddress.deliveryZone = dObj;
        this.formAddress.zoneMethodId = dObj.deliveryMethod;
      }
    },
    nextAddress() {
      this.$emit('submit', this.formAddress);
    },
  },
};
</script>
